exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-68a42dfa].template-card {\n  padding: 25px;\n  background-color: whitesmoke;\n  margin: 25px;\n  border-radius: 5px;\n  -webkit-box-shadow: 1px 2px 3px 2px rgba(148, 121, 148, 0.7);\n  -moz-box-shadow: 1px 2px 3px 2px rgba(148, 121, 148, 0.7);\n  box-shadow: 1px 2px 3px 2px rgba(148, 121, 148, 0.7);\n}\n", ""]);

